import { Breadcrumbs, Stack, Divider, Grid, Typography } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import { Link } from 'react-router-dom';
import './SCUIBreadCrumb.scss';

export const SCUIBreadCrumb = (props: any) => {
    const handleBreadcrumbClick = () => {
        if (props.onClick) {
            props.onClick();
        }
    };
    return (
        <Grid
            sx={{ paddingBottom: '2rem' }}
            size={{
                xs: 12,
                sm: 12,
                lg: 12,
                xl: 12
            }}>
            <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
                {props.title && <h1 className="headtxt">{props.title}</h1>}
                {props.onlyTitle && <h1 className="headtxt">{props.onlyTitle}</h1>}

                {(props.homeIconLink != undefined || props.title != undefined || props.components != undefined) && (
                    <Breadcrumbs aria-label="breadcrumb" sx={{ paddingTop: 1 }}>
                        {!props.dontShowHome && (
                            <Link to={'home'} className="sign-in-link">
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                            </Link>
                        )}
                        {props.homeIconLink && (
                            <Link to={props.homeIconLink} className="sign-in-link">
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                            </Link>
                        )}

                        {props.title && (
                            <Link to={props.componentLink} onClick={handleBreadcrumbClick}>
                                {props.title}
                            </Link>
                        )}
                        {props.components &&
                            props.components.map((blog: any, index: number) => 
                                blog.link == undefined ? (
                                    <Typography key={index} variant="subtitle1">{blog.title} </Typography>
                                ) : (
                                    <Link
                                        key={index}
                                        to={{ pathname: blog.link, state: blog.transferState }}
                                        onClick={blog.onClick ? blog.onClick : () => null}
                                    >
                                        {blog.title}
                                    </Link>
                                )
                            )}
                    </Breadcrumbs>
                )}
            </Stack>
        </Grid>
    );
};
